import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MedLocalizationModule } from "@mk/med-localization";

import { MedE2eTestIdDirective } from "./directives/med-e2e-test-id.directive";

@NgModule({
  declarations: [
    MedE2eTestIdDirective,
  ],
  imports: [
    CommonModule,
    MedLocalizationModule,
  ],
  exports: [
    MedE2eTestIdDirective,
  ],
})
export class MedE2eTestIdModule {}
